export function onSave(grid, callback) {
	if (callback) {
		grid.bind('save', callback);
	}
}
